import DataGrid, { Column, Editing, FilterRow, HeaderFilter, Sorting } from "devextreme-react/data-grid";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { hinhThucMienGiamApi } from "../../../../api/hinhThucMienGiamApi";
import { khoanNopApi } from "../../../../api/khoanNopApi";
import { Button } from "../../../../components/buttons";
import { AnimationPopup } from "../../../../components/modal";
import { PlaceHolder } from "../../../../components/place-holder";
import { showNotify } from "../../../../helpers/toast";
import { sf_hinhthucmiengiam } from "../../../../models/response/category/sf_hinhthucmiengiam";
import { RootState } from "../../../../state/reducers";
type MienGiamEditItemsModalProps = {
    sf_hinhthucmiengiam: sf_hinhthucmiengiam,
    onClose: () => void,
    onChanged: () => void,
    animationOf: string
}
export const MienGiamEditItemsModal = (props: MienGiamEditItemsModalProps) => {
    const [sf_khoannop_viewmodel_miengiams, set_sf_khoannop_viewmodel_miengiams] = useState<any[]>([]);
    const [isSaving, SetIsSaving] = useState<boolean>(false);
    const [isLoaded, SetIsLoaded] = useState<boolean>(false);
    const { dm_coso_id } = useSelector((x: RootState) => x.common);
    const grid = useRef<any>(null);
    useEffect(() => {
        handelReload();
    }, [])
    const handelReload = async () => {
        if (props.sf_hinhthucmiengiam.id > 0) {
            SetIsLoaded(false)
            let isLoading: boolean = true;
            const interval_obj = setInterval(() => {
                if (!isLoading) {
                    SetIsLoaded(true);
                    clearInterval(interval_obj);
                }
            }, 1000)
            const res = await khoanNopApi.select_by_miengiam(props.sf_hinhthucmiengiam.id);
            if (res.is_success && res.data !== undefined && res.data !== null) {
                const dataSource = res.data.filter((c: any) => c.dm_coso_id === dm_coso_id);
                set_sf_khoannop_viewmodel_miengiams(dataSource);
            }
            else set_sf_khoannop_viewmodel_miengiams([]);
            isLoading = false;

        } else {
            set_sf_khoannop_viewmodel_miengiams([]);
        }
    }

    const onToolbarPreparing = (e: any) => {
        e.toolbarOptions.items.forEach((v: any) => {
            if (v.name == "saveButton") {
                v.options.icon = "save";
                v.options.text = "Cập nhật";
                v.showText = "always";
                v.visible = false;
            }
            else if (v.name == "revertButton") {
                v.options.icon = "revert";
                v.options.text = "Hoàn tác";
                v.showText = "always";
            }
            else if (v.name == "addRowButton") {
                v.options.icon = "plus";
                v.options.text = "Thêm KPI";
                v.showText = "always";
            }
        });
    }

    const onSaving = async (e: any) => {
        e.cancel = true;
        if (e.changes.length) {

            let payload = [];
            payload = e.changes.map((change: any) => {
                const obj = sf_khoannop_viewmodel_miengiams.filter(x => x.id == change.key)[0];
                let data = {
                    ...change.data,
                    sf_hinhthucmiengiam_id: props.sf_hinhthucmiengiam.id,
                    id: change.key,
                    sf_hinhthucmiengiam_chitiet_id: obj.sf_hinhthucmiengiam_chitiet_id
                };
                return data;
            });

            e.promise = processBatchRequest(payload, e.changes, e.component);
        }
    }
    const processBatchRequest = async (payload: any, changes: any, component: any) => {
        SetIsSaving(true);
        const res = await hinhThucMienGiamApi.save_change_chitiets(payload);
        SetIsSaving(false)
        if (res.is_success) {
            props.onChanged();
            showNotify({ message: "Cập nhật thành công", type: "success" })
        } else {
            showNotify({ message: "Có lỗi " + (res.message || ""), type: "error" })
        }

    }
    const onClose = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [props.animationOf])
    return (
        <AnimationPopup
            width="60%"
            animationOf={props.animationOf}
            title="Điều chỉnh % miễn giảm"
            maxWidth={700}
            onClose={onClose}
            >
            <div>
                {isLoaded && <div>
                    <DataGrid
                        ref={grid}
                        keyExpr={"id"}
                        dataSource={sf_khoannop_viewmodel_miengiams}
                        columnHidingEnabled={false}
                        //defaultColumns={columns}
                        columnAutoWidth={true}
                        showBorders={true}
                        showColumnLines={false}
                        showRowLines={false}
                        rowAlternationEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode={"nextColumn"}
                        hoverStateEnabled={true}
                        focusedRowEnabled={false}
                        className={"table-noborder-left"}
                        noDataText="Không có dữ liệu"
                        paging={{ enabled: false }}
                        height={window.innerHeight - 300}
                        onToolbarPreparing={onToolbarPreparing}
                        onSaving={onSaving}
                        wordWrapEnabled
                    >
                        <FilterRow visible={true} />
                        <HeaderFilter visible={true} />
                        <Editing
                            mode="batch"
                            allowUpdating={true} selectTextOnEditStart={true} />
                        <Sorting mode="multiple" />

                        <Column dataField="nhom_khoan_nop" allowEditing={false} caption="Nhóm" groupIndex={0}></Column>
                        <Column dataField="ma_khoan_nop" allowEditing={false} caption="Mã khoản nộp"></Column>
                        <Column dataField="ten_khoan_nop" allowEditing={false} caption="Tên khoản nộp"></Column>
                        <Column dataField="phan_tram_mien_giam" caption="% miễn giảm"></Column>
                        <Column dataField="so_tien_mien_giam" caption="Số tiền cố định"></Column>
                    </DataGrid>
                    <div className="pop-up-actions">
                        <Button type="normal" icon="fa fa-times" text="Đóng" onClick={props.onClose}></Button>{' '}
                        <Button type="normal" isLoading={isSaving} text="Cập nhật" icon="fas fa-check-square" onClick={() => {
                            grid.current.instance.saveEditData();
                        }}></Button>
                    </div>
                </div>
                }
                {!isLoaded && <PlaceHolder line_number={20} />}
            </div>
        </AnimationPopup>
    );
}